import './App.css';
import logo from './logo.svg';
import Home from './pages/Home';

function App() {
  return (
    <Home />
  );
}

export default App;
